export default "__VITE_ASSET__DteQxdw0__"